/* eslint-disable react-hooks/rules-of-hooks */
import DashboardLayout from "@/components/dashboard/layout";
import ProductCard from "@/components/global/ProductCard";
import EmptyGuard from "@/components/global/Empty";
import Image from "@/components/global/Image";

import { useTranslation } from "next-i18next";
import { useWishlist } from "@/context/wishlist";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useEffect } from "react";
import { wishlist_updated } from "@/utils/gtm";
import { fetchHandshake } from "@/services/handshake";
function index() {
  const { wishlist } = useWishlist();
  const favouriteProducts = Object.values(wishlist);
  const {
    t,
    i18n: { language },
  } = useTranslation("dashboard");
  useEffect(() => {
    wishlist_updated(favouriteProducts, "wishlist_viewed");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <DashboardLayout>
      <h1 className="font-bold sm:text-2xl">
        {language === "en" ? "My Favourites" : "المفضلة"}
      </h1>
      <EmptyGuard
        title={t("Faviorite Is Empty")}
        data={favouriteProducts}
        description={t("NoFavDescription")}
        icon={
          <Image
            src="/imgs/empty-favourite.svg"
            alt="No Fav Img!"
            className="mb-5 w-44 max-sm:h-44 sm:w-72"
          />
        }
      >
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-6 xl:col-span-6 sm:gap-5">
          {favouriteProducts?.map((product, key) => (
            <ProductCard product={product} key={key} />
          ))}
        </div>
      </EmptyGuard>
    </DashboardLayout>
  );
}

export default index;

export async function getServerSideProps({ req, res, locale }) {
  // get handshake from cookies or generate new handshake
  await fetchHandshake({ req, res, locale });

  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "dashboard"])),
    },
  };
}
